import {CurrencyPipe} from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController, NavController} from '@ionic/angular';
import {DualAuthService} from '@wlp/ui-bs-cashout';
import {UiBsTranslateService} from '@wlp/ui-bs-translate';
import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';
import {BrMaskDirective} from 'br-mask';
import * as moment from 'moment';
import {LayoutConfigModel} from 'src/app/core/layout/models/layout-config.model';
import {LayoutConfigService} from 'src/app/core/layout/services/layout-config.service';
import {LoadingService} from 'src/app/core/layout/services/loading.service';
import {ModalAlertComponent} from '../../../../../modals/modal-alert/modal-alert.component';
import {ModalDetailDualAuth} from '../../../../../modals/modal-detail-dualauth/modal-detail-dualauth.component';
import {ModalTokenComponent} from '../../../../../modals/modal-token/modal-token.component';
import {
  ModalTrackingProcessComponent
} from '../../../../../modals/modal-tracking-process/modal-tracking-process.component';
import {ApprovalsDataFilterPipe} from './transaction-approvals-filter.pipe';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'transaction-approvals',
  templateUrl: './transaction-approvals.page.html',
  styleUrls: ['./transaction-approvals.page.scss'],
  providers: [CurrencyPipe, ApprovalsDataFilterPipe],
})
export class TransactionApprovalsPage implements OnInit {
  @ViewChild(`btnListDate`, {static: false}) public btnListDate: ElementRef;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  userProfile: UserInfoProfile;

  private OPERATION = 1002;

  public filterDays = 7
  
  public startDate: string;
  public endDate: string;

  public rangeDateFilter: FormGroup

  public data = []
  public listOfApproves = []
  public pagination: any
  public quantity: number;
  public totalValue: number

  public dataChecked = []
  public dataLength: number

  public itemsPerPage: number = 10;
  public itemsPerPageOptions: number[] = [10, 20, 30, 50, 100];

  public pageNumber: number = 1

  public isChecked: boolean = false;
  public masterCheck: boolean;
  public isIndeterminate: boolean;

  public modalIsOpen: boolean;

  public prevStateData = []

  public iconSkipLast = './assets/icon/icon-material-skip-last.svg';
  public iconNavigateLast = './assets/icon/icon-material-navigate-last.svg';
  public iconNavigateNext = './assets/icon/icon-material-navigate-next.svg';
  public iconSkipNext = './assets/icon/icon-material-skip-next.svg';

  public customPopoverOptionsOperation: any;
  public customPopoverOptionsTypeView: any;

  public selectedStatus: Array<string> = ["PENDING"]
  public selectedTypeOperation = "ALL"

  public statusApprove = [
    { value: "PENDING", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.STATUS_SELECT.PENDING" },
    { value: "PROCESSING", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.STATUS_SELECT.PROCESSING" },
    { value: "FINISHED", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.STATUS_SELECT.FINISHED" },
    { value: "REPROVED", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.STATUS_SELECT.REPROVED" },
    { value: "NOT_AUTHORIZED", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.STATUS_SELECT.NOT_AUTHORIZED" },
    { value: "CANCELED", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.STATUS_SELECT.CANCELED" },
  ]

  public typeOperationApprove = [
    { value: "ALL", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.TYPE_OF_OPERATION_SELECT.ALL" },
    { value: "TRANSFER", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.TYPE_OF_OPERATION_SELECT.TRANSFER" },
    { value: "PAYMENT", label: "CASH_OUT.APPROVALS.TABLE_FILTERS.TYPE_OF_OPERATION_SELECT.PAYMENT" },
  ]

  public hasCurrentUserOnApprover = []

  constructor(
    private dualAuthService: DualAuthService,
    protected userInfoService: UserInfoService,
    public pipeCurency: CurrencyPipe,
    public pipeFilter: ApprovalsDataFilterPipe,
    public modalController: ModalController,
    public activatedRoute: ActivatedRoute,
    public loadingService: LoadingService,
    private layoutConfigService: LayoutConfigService,
    private navCtrl: NavController,
    private translate: UiBsTranslateService,
    public brMask: BrMaskDirective,
    private formBuilder: FormBuilder,
  ) {}

  public async ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.loadUser()
    this.createRangeFilterForm()

    const start = new Date(this.rangeDateFilter.value.startDate.replaceAll("/", " ").split(" ").reverse())
    const end = new Date(this.rangeDateFilter.value.endDate.replaceAll("/", " ").split(" ").reverse())

    this.startDate = moment(start).format()
    this.endDate = moment(end).format()
  }

  loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;

        const startDate = moment(new Date()).subtract(this.filterDays, "days").format()
        const endDate = moment(new Date()).format()
        
        this.getTransactions(user.uuidAccount, this.selectedTypeOperation, this.selectedStatus, startDate, endDate, this.itemsPerPage, this.pageNumber)
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  public createRangeFilterForm() {
    const startValue = moment(new Date()).subtract(this.filterDays, "days").format("DD/MM/YYYY")
    const endValue = moment(new Date()).format("DD/MM/YYYY")

    this.rangeDateFilter = this.formBuilder.group({
      startDate: new FormControl(startValue),
      endDate: new FormControl(endValue),
    })
  }

  public getTransactions(uuidAccount: string, typeOperation: any, status: any, dateStart: any, dateEnd: any, itemsPerPage: number, pageNumber: number) {
    this.loadingService.show()

    this.pagination = {}
    this.dataLength = 0
    this.data = []

    this.dualAuthService.getAllTransactionsPaginated(uuidAccount, typeOperation, status, dateStart, dateEnd, itemsPerPage, pageNumber).subscribe(
      res => {
        this.pagination = res[0].pagination
        this.dataLength = res[0].data.length
        res[0].data.map(data => {
          var userIsEnableToApprove: boolean = true

          for(var i = 0; i < data.listApproves.length; i++) {
              if (data.listApproves[i].isUserSessionApproved) {
                  userIsEnableToApprove = false;
                  break;
              }
          }
          this.data.push({
            ...data,
            isItemChecked: false,
            userIsEnableToApprove,
            isAlreadyApproved: data.numberOfApprovals >= Number(data.amountRequired)
          })
        })

        this.prevStateData = this.data
      },
      err => console.log(err),
      () => {
        this.loadingService.hide()
      }
    )
  }

  // regra para reset do css após seleção de um dos botões de filtro
  public resetBtnFilters(listClass: string, list: string) {
    let btnsHolder: HTMLElement;

    if (list === 'date') {
      btnsHolder = (this.btnListDate.nativeElement as HTMLElement);
    }

    const btns: NodeListOf<HTMLElement> = btnsHolder.querySelectorAll(listClass);
    btns.forEach((btn) => btn.classList.remove('primary'));
  }

  checkMaster(event) {
    this.masterCheck = event.target.checked
  
    setTimeout(()=>{
      this.data.forEach(obj => {
        if(obj.userIsEnableToApprove) {
          obj.isItemChecked = !this.masterCheck;
        }
      });
    });
  }

  checkEvent() {
    const totalItemsEnableToApprove = []
    this.dataChecked = []
    let checked = 0;
    var sum = 0;

    this.data.map(item => {
      if (item.userIsEnableToApprove) {
        totalItemsEnableToApprove.push(item)
      }

      if (item.isItemChecked) {
        this.dataChecked.push(item)
        checked++
      };
    })

    if (checked > 0 && checked < totalItemsEnableToApprove.length) {
      //If even one item is checked but not all
      this.isIndeterminate = true;
      this.isChecked = true;
      this.masterCheck = false;
    } else if (checked == totalItemsEnableToApprove.length) {
      //If all are checked
      this.masterCheck = true;
      this.isChecked = true;
      this.isIndeterminate = false;
    } else {
      //If none is checked
      this.isIndeterminate = false;
      this.isChecked = false;
      this.masterCheck = false;
    }

    
    for(var i = 0 ; i < this.dataChecked.length; i++){
      sum+=this.dataChecked[i].amountPaid;
    }
    
    this.totalValue = sum
    this.quantity = this.dataChecked.length;
  }

  // altera o css dos botões de filtro por dias e chama o filtro pelos botões
  public filterByDay(event?: Event, days: number = 7) {
    this.resetBtnFilters('.btn-filter', 'date');
    this.pageNumber = 1

    if (event !== undefined) {
      const element: HTMLElement = (event.target as HTMLElement);
      element.classList.add('primary');
    } else {
      const initialBtnFilterDays = document.getElementById("initialBtnFilter")
      initialBtnFilterDays.classList.add('primary');
    }

    this.filterDays = days

    const newStartDateRange = moment(new Date()).subtract(this.filterDays, "days").format("DD/MM/YYYY")

    this.rangeDateFilter.patchValue({
      startDate: newStartDateRange,
    })

    const start = new Date(this.rangeDateFilter.value.startDate.replaceAll("/", " ").split(" ").reverse())
    const end = new Date(this.rangeDateFilter.value.endDate.replaceAll("/", " ").split(" ").reverse())

    this.startDate = moment(start).format()
    this.endDate = moment(end).format()


    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  // filtro pelo status da aprovação pelo ion-select
  public async filterStatus() {
    const allStatusArrayToCompare = ["PENDING", "PROCESSING", "FINISHED", "REPROVED"]
    this.pageNumber = 1

    if(JSON.stringify(this.selectedStatus) === JSON.stringify(allStatusArrayToCompare)) {
      const allStatus = ["ALL"]

      this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, allStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
    } else {
      this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
    }
  }

  // filtro pelo tipo da operação da aprovação pelo ion-select
  public async filterByType() {
    this.pageNumber = 1

    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  public filterByRangeDate() {
    this.resetBtnFilters('.btn-filter', 'date');
    this.pageNumber = 1

    const start = new Date(this.rangeDateFilter.value.startDate.replaceAll("/", " ").split(" ").reverse())
    const end = new Date(this.rangeDateFilter.value.endDate.replaceAll("/", " ").split(" ").reverse())

    this.startDate = moment(start).format()
    this.endDate = moment(end).format()

    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  // filtro pelo search
  public searchFilter(searchValue: string) {    
    this.data = this.pipeFilter.transform(this.prevStateData, searchValue);
  }

  public applyStatusText(aproval) {
    // ["PENDING", "PROCESSING", "FINISHED", "REPROVED"] 
    switch (aproval.status) {
      case 'PENDING':
      case 'PROCESSING': 
        return this.translate.applyTranslate('CASH_OUT.APPROVALS.TABLE.STATUS_BUTTON.IN_PROCESS', { 
          numberOfApprovals: aproval.numberOfApprovals, 
          amountRequired: aproval.amountRequired 
        })
      case 'FINISHED': 
        return this.translate.applyTranslate('CASH_OUT.APPROVALS.TABLE.STATUS_BUTTON.APPROVED')
      case 'REPROVED':
        return this.translate.applyTranslate('CASH_OUT.APPROVALS.TABLE.STATUS_BUTTON.REPROVED')
      case 'NOT_AUTHORIZED':
        return this.translate.applyTranslate('CASH_OUT.APPROVALS.TABLE.STATUS_BUTTON.NOT_AUTHORIZED')
      case 'CANCELED':
        return this.translate.applyTranslate('CASH_OUT.APPROVALS.TABLE.STATUS_BUTTON.CANCELED')
    }

    
  }
  
  public applyStatusClass(status) {
    switch(status) {
      case 'FINISHED': 
        return 'aproved-advice approved'
      case 'REPROVED':
        return 'aproved-advice reproved'
      case 'NOT_AUTHORIZED': 
        return 'aproved-advice not-authorized'
      case 'CANCELED':
        return 'aproved-advice canceled'
      default:
        return 'aproved-advice'
    }
  }
  
  // traduz o texto do tipo
  public statusTranslate(type, i) {
    switch (type) {
      case '919': {
        return 'PIX';
      }
      case '901':
      case '120': {
        return 'TRANSFERÊNCIA';
      }
      case '112': {
        return 'PAGAMENTO';
      }
      default: {
        return '--';
      }
    }
  }

  async handleChangeItemsPerPage(itemsPerPage: number) {
    this.itemsPerPage = itemsPerPage

    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  async handleGoToFirstPage() {
    this.pageNumber = 1

    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  async handleGoToLastPage() {
    this.pageNumber = this.pagination.totalPages

    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  async handleGoToNextPage() {
    if (this.pageNumber < this.pagination.totalPages) {
      this.pageNumber = this.pageNumber + 1
    }

    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  async handleGoToPrevPage() {
    if (this.pageNumber > 0) {
      this.pageNumber = this.pageNumber - 1
    }

    this.getTransactions(this.userProfile.uuidAccount, this.selectedTypeOperation, this.selectedStatus, this.startDate, this.endDate, this.itemsPerPage, this.pageNumber)
  }

  // Modal de detalhes da aprovação
  private async modalPendingApproval(i: number) {
    const modalPending = await  this.modalController.create({
      component: ModalTrackingProcessComponent,
      cssClass: 'modal-tracking-process',
      componentProps: {
        listApproves: this.data[i].listApproves,
        amountRequired: this.data[i].listApproves.length,
        numberOfApprovals: this.data[i].numberOfApprovals,
        confirmBtn:  '',
      },
      backdropDismiss: false,
    });
    return await modalPending.present();
  }

  // Confirmação da operação de um item
  private async modalConfirmOne(approve: boolean, i: number) {
    if (!this.isChecked) {
      this.dataChecked.push(this.data[i])
      this.totalValue = this.data[i].amountPaid
      this.quantity = this.dataChecked.length;
    }

    const transactionsId = this.dataChecked.map((transaction) => transaction.transactionId);
    const body = {transactionIds: transactionsId};
    this.loadingService.hide();
    const modalConfirm = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-dual-auth',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.MESSAGE',
        description: approve ? this.translate.applyTranslate('CASH_OUT.APPROVALS.MODAL.CONFIRMATION.DESCRIPTION_APPROVE_1', {
          quantity: this.quantity,
          totalValue: this.formatReal(this.totalValue),
        }) : this.translate.applyTranslate('CASH_OUT.APPROVALS.MODAL.CONFIRMATION.DESCRIPTION_REPROVE_1', {
          quantity: this.quantity,
          totalValue: this.formatReal(this.totalValue),
        }),
        alert: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.ALERT',
        confirmBtn: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.BUTTON_1',
        cancelBtn: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.BUTTON_2',
        confirmation: true,
        translate: true,
      },
      backdropDismiss: false,
    });
    modalConfirm.onDidDismiss().then((callback) => {
      if (callback.data === true) {
        this.modalToken(approve, body);
      }
    });
    return await modalConfirm.present();
  }

  private formatReal(vl: any) {
    let value = vl;
    value = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);
    return value;
  }

  // Confirmação da operação por checked
  private async modalConfirmChecked(approve: boolean) {
    const transactionsIds = this.dataChecked.map((transaction) => transaction.transactionId);
    const body = {transactionIds: transactionsIds};
    const fomatter = new Intl.NumberFormat('pt-br', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });

    this.loadingService.hide();

    let description: string;
    let statusAproved: string;
    if (approve) {
      statusAproved = 'APPROVED';
      if (this.quantity === 1) {
        description = 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.DESCRIPTION_APPROVE_1';
      } else if (this.quantity > 1) {
        description = 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.DESCRIPTION_APPROVE_2';
      }
    } else if (!approve) {
      statusAproved = 'REPROVED';
      if (this.quantity === 1) {
        description = 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.DESCRIPTION_REPROVE_1';
      } else if (this.quantity > 1) {
        description = 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.DESCRIPTION_REPROVE_2';
      }
    }
    
    const modalConfirm = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-dual-auth',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.MESSAGE',
        description: approve ? this.translate.applyTranslate(description, {
          quantity: this.quantity,
          totalValue: this.formatReal(this.totalValue),
        }) : this.translate.applyTranslate(description, {
          quantity: this.quantity,
          totalValue: this.formatReal(this.totalValue),
        }),
        alert: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.ALERT',
        confirmBtn: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.BUTTON_1',
        cancelBtn: 'CASH_OUT.APPROVALS.MODAL.CONFIRMATION.BUTTON_2',
        confirmation: true,
        translate: true,
      },
      backdropDismiss: false,
    });
    modalConfirm.onDidDismiss().then((callback) => {
      if (callback.data === true) {
        this.modalToken(approve, body);
      }

      this.dataChecked = []
      this.isChecked = false
      this.totalValue = 0
      this.quantity = 0
    });
    return await modalConfirm.present();
  }

  // Validação com token
  private async modalToken(approve: boolean, body: any) {
    let statusAproved: string;
    if (approve) {
      statusAproved = 'APPROVED';
    } else {
      statusAproved = 'REPROVED';
    }
    this.loadingService.hide();
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
      },
      backdropDismiss: false,
    });
    modalToken.onDidDismiss().then((data) => {
      if (data) {
        body.codeAuthorization = data.role;
        this.confirmTransaction(statusAproved, body);
      }
      this.modalNotification(approve);

      this.dataChecked = []
      this.isChecked = false
      this.totalValue = 0
      this.quantity = 0
      this.isIndeterminate = false
    });
    return await modalToken.present();
  }

  // Notificação de sucesso ou erro
  private async modalNotification(approve: boolean) {
    let description: string;

    if (approve) {
      description =
        this.quantity === 1
          ? 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.DESCRIPTION_APPROVE_1'
          : 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.DESCRIPTION_APPROVE_2';
    } else {
      description =
        this.quantity === 1
        ? 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.DESCRIPTION_REPROVE_1'
        : 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.DESCRIPTION_REPROVE_2';
    }
    this.loadingService.hide();
    const modalNotification = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: approve ? 'success' : 'warning-circle',
        message: 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.MESSAGE_1',
        description,
        confirmBtn: 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.BUTTON_1',
        translate: true,
      },
      backdropDismiss: false,
    });
    modalNotification.onDidDismiss().then(() => {
      this.pageNumber = 1

      this.getTransactions(
        this.userProfile.uuidAccount, 
        this.selectedTypeOperation, 
        this.selectedStatus, 
        this.startDate, 
        this.endDate, 
        this.itemsPerPage, 
        this.pageNumber
      )
    });
    return await modalNotification.present();
  }

  // Notificação de nada
  private async modalNotificationAlert() {
    this.loadingService.hide();
    const modalNotificationAlert = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-dual-auth',
      componentProps: {
        message: 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.MESSAGE_2',
        alert: 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.ALERT',
        confirmBtn: 'CASH_OUT.APPROVALS.MODAL.NOTIFICATION.BUTTON_2',
        translate: true,
      },
      backdropDismiss: false,
    });
    modalNotificationAlert.onDidDismiss().then((data) => {
    });
    return await modalNotificationAlert.present();
  }

  public voucherChoose(initialTypeVoucher) {
    switch (initialTypeVoucher) {
    case '112':
      return 'payment';
    case '901':
    case '120':
      return 'transfer';
    }
  }

  // modal de detalhamento da operação
  private async  modalDetail(i: number) {
    const data = this.data[i];
    this.loadingService.hide();
    const initialTypeVoucher: string = this.data[i].typeVoucher;
    const typeVoucher = this.voucherChoose(initialTypeVoucher);
    const modalDetail = await this.modalController.create({
      component: ModalDetailDualAuth,
      cssClass: 'modal-detail-dualauth',
      componentProps: {
        title: this.translate.applyTranslate('CASH_OUT.APPROVALS.MODAL.DETAIL.TITLE'),
        typeVoucher,
        typeTransfer: data.bankDestination === 'Urbano Bank' ? this.translate.applyTranslate('CASH_OUT.APPROVALS.MODAL.DETAIL.BETWEEN_ACCOUNTS') : this.translate.applyTranslate('CASH_OUT.APPROVALS.MODAL.DETAIL.INTERBANK'),
        namePayer: data.namePayer,
        cpfCnpjPayer: data.cpfCnpjPayer,
        bankPayer: data.bankPayer,
        agencyPayer: data.agencyPayer,
        currentAcountPayer: data.currentAcountPayer,
        nameDestination: data.nameDestination,
        cpfCnpjDestinatario: data.cpfCnpjDestination,
        bankDestination: data.bankDestination,
        agencyDestination: data.agencyDestination,
        accountDestination: data.accountDestination,
        totalPay: data.amountPaid,
        amountPaid: data.amountPaid,
        dateSchedule: data.dateSchedule,
        dateExpiration: data.dateExpiration,
        interestValue: data.interestValue,
        fineValue: data.fineValue,
        discount: data.discount,
        dateRegister: data.dateRegister,
        barCode: data.barCode,
      },
      backdropDismiss: false,
    });
    modalDetail.onDidDismiss().then(() => {
    });
    return await modalDetail.present();
  }

  // recebe os valores de quantity e totalValue
  public getAmountAndQuantity() {
    this.quantity = 0;
    this.totalValue = 0;
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].isItemChecked) {
        this.totalValue += this.data[i].amountPaid;
        this.quantity = this.dataChecked.length;
      }
    }
    return this.quantity && this.totalValue;
  }
  // Verifica se existem itens selecionados
  public validateChecked(approve: boolean) {
    this.getAmountAndQuantity();
    if (this.quantity === 0) {
      this.modalNotificationAlert();
    } else {
      this.modalConfirmChecked(approve);
    }
  }

  // Chama o metodo que envia a confirmação ou reprovação da transação
  public confirmTransaction(statusAproved: any, transactionsId: any) {
    const approver = {
      name: this.userProfile.nameComplete,
      dateOfAproval: new Date()
    }

    return new Promise<void>((resolve, reject) => {
      this.dualAuthService.confirmTransaction(statusAproved, transactionsId)
        .subscribe(() => {
          resolve();
        }, (error) => {
          console.error(error);
          reject(error);
        });
    });
  }

  public goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }

}
